import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LoaderService } from 'app/loader.service';
import { HubService } from 'app/hub.service';
import { ApiService } from 'app/api.service';
import { FilesService } from 'app/files.service';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Ng2Highcharts } from 'ng2-highcharts';
import { ChartsService } from 'app/charts.service';
import { Angulartics2 } from 'angulartics2';
import { exists } from 'fs';
declare var alertify: any;

@Component({
  selector: 'app-workout-editor',
  templateUrl: './workout-editor.component.html',
  styleUrls: ['./workout-editor.component.scss']
})
export class WorkoutEditorComponent implements OnInit {

  // Define some public variables
  workout: object = {}; // holds our inital workout model from the API
  draftWorkout: object = {}; // holds the workout model we will save
  timeTotal: number = 0; // holds a sum of the segment durations
  formWatcher: any; // used to detect form changes via observable
  form: FormGroup;
  segments: any[];
  profileChartOptions: any;
  activeSegmentIndex: number = null;
  flashNoteMaxLength: number = 35;
  modalOverlayVisible: boolean = false;
  keyboardShortcutsModalVisible: boolean = false;
  notesVisible: boolean = false;
  insertSets: object = {
    "newSegment": {
      "name": "New Segment",
      "segments": [
        {
          "duration": 300,
          "start": 100,
          "end": 100,
          "hr": 50,
          "cadence": 90,
          "lap": true,
          "flashNote": null,
          "flashNoteOffset": 5
        }
      ]
    },
    "20minWarmup": {
      "name": "20 Minute Warmup",
      "segments": [
        {
          "duration": 300,
          "start": 45,
          "end": 45,
          "hr": 60,
          "cadence": 90,
          "lap": false,
          "flashNote": "Focus on cadence, reduce resistance if HR too high",
          "flashNoteOffset": 10
        },
        {
          "duration": 120,
          "start": 55,
          "end": 55,
          "hr": 65,
          "cadence": 95,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 120,
          "start": 65,
          "end": 65,
          "hr": 70,
          "cadence": 100,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 120,
          "start": 70,
          "end": 70,
          "hr": 75,
          "cadence": 105,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 90,
          "start": 75,
          "end": 75,
          "hr": 80,
          "cadence": 110,
          "lap": false,
          "flashNote": "Focus on cadence, reduce resistance if HR too high",
          "flashNoteOffset": 5
        },
        {
          "duration": 30,
          "start": 95,
          "end": 95,
          "hr": 85,
          "cadence": 118,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 120,
          "start": 45,
          "end": 45,
          "hr": 70,
          "cadence": 90,
          "lap": false,
          "flashNote": "Reduce resistance if HR not coming down",
          "flashNoteOffset": 5
        },
        {
          "duration": 6,
          "start": 150,
          "end": 15,
          "hr": 85,
          "cadence": 150,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 60,
          "start": 45,
          "end": 45,
          "hr": 70,
          "cadence": 90,
          "lap": false,
          "flashNote": "Reduce resistance if HR not coming down",
          "flashNoteOffset": 5
        },
        {
          "duration": 6,
          "start": 150,
          "end": 15,
          "hr": 85,
          "cadence": 150,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 60,
          "start": 45,
          "end": 45,
          "hr": 70,
          "cadence": 90,
          "lap": false,
          "flashNote": "Reduce resistance if HR not coming down",
          "flashNoteOffset": 5
        },
        {
          "duration": 6,
          "start": 150,
          "end": 15,
          "hr": 85,
          "cadence": 150,
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        },
        {
          "duration": 162,
          "start": 45,
          "end": 45,
          "hr": 70,
          "cadence": 90,
          "lap": false,
          "flashNote": "Reduce resistance if HR not coming down",
          "flashNoteOffset": 5
        }
      ]
    },
    "10minWarmup": {
      "name": "10 Minute Warmup",
      "segments": [
        {
          "duration": 120,
          "start": 35,
          "end": 35,
          "hr": 60,
          "cadence": 90,
          "lap": false,
          "flashNote": "2min at 35%",
          "flashNoteOffset": 2
        },
        {
          "duration": 120,
          "start": 40,
          "end": 40,
          "hr": 62,
          "cadence": 90,
          "lap": false,
          "flashNote": "2min at 40%",
          "flashNoteOffset": 2
        },
        {
          "duration": 120,
          "start": 45,
          "end": 45,
          "hr": 65,
          "cadence": 90,
          "lap": false,
          "flashNote": "2min at 45%",
          "flashNoteOffset": 2
        },
        {
          "duration": 120,
          "start": 50,
          "end": 50,
          "hr": 70,
          "cadence": 90,
          "lap": false,
          "flashNote": "2min at 50%",
          "flashNoteOffset": 2
        },
        {
          "duration": 120,
          "start": 55,
          "end": 55,
          "hr": 75,
          "cadence": 90,
          "lap": false,
          "flashNote": "Last segment. 2min at 55%",
          "flashNoteOffset": 2
        }
      ]
    }
  };
  froalaOptions = {
    key: "zC4E4I4D3kB6B5C4A5F3E3E3F2A5B3D-13teqreaboC6obc==",
    charCounterCount: false,
    paragraphFormat: {
      N: 'Normal',
      H1: 'Heading 1',
      H2: 'Heading 2',
      H3: 'Heading 3'
    },
    quickInsertTags: null,
    theme: 'wattbike',
    toolbarButtons: ['bold', 'italic', '|', 'paragraphFormat', '|', 'undo', 'redo', '|', 'html' ],
    toolbarButtonsSM: ['bold', 'italic', '|', 'paragraphFormat', '|', 'undo', 'redo', '|', 'html' ],
    toolbarButtonsXS: ['bold', 'italic', '|', 'paragraphFormat', '|', 'undo', 'redo', '|', 'html' ]
  }

  userPerformanceState: {} = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loaderService: LoaderService,
    private apiService: ApiService,
    private hubService: HubService,
    private formBuilder: FormBuilder,
    private chartsService: ChartsService,
    private filesService: FilesService,
    private angulartics2: Angulartics2
  ) {

    // get user's perfoamce state to work out zones
    const where = {"user" :{
      __type: "Pointer",
      objectId: this.apiService.Parse.User.current().id,
      className: "_User"
    }};
    this.hubService.getResource('UserPerformanceState', where, 1, null, null, null)
      .subscribe(
      response => {
        this.userPerformanceState = response[0];
        // console.log(JSON.stringify(response));
      },
      error => {
        // console.log(error);
        alertify.error(error);
      }
    );

    this.loaderService.setLoaded(); // here for now to shut up the annoying errors
    if (!this.apiService.Parse.User.current().id) {
      // send the user to log in if they are not already
    }
  }

  ngOnInit() {

    // console.log(JSON.stringify(this.apiService.Parse.User.current()));

    // start by loading the Workout to edit or loading a blank workout
    if (this.route.snapshot.params.id) {
      // edit existing workout
      this.getWorkout(this.route.snapshot.params.id);
    } else {
      // create new workout
      this.initNewWorkout();
      this.initForm(); // build a form populated with the Workout data
      this.insert('10minWarmup', 'start');
      this.updateDraftWorkout(); // trigger an initial draw of the chart
      this.subscribeToForm(); // detect form changes and update the chart
      this.loaderService.setLoaded();
    }
  }

  // load our workout
  getWorkout(workout) {
    this.hubService.getResource('Workout', { "objectId": workout }, 1, null, null, null)
      .subscribe(
      workouts => {
        this.workout = workouts[0];
        this.loaderService.setLoaded();
        this.initForm(); // build the form populated with the Workout data
        this.populateSegments(workouts[0].segments); // populate the segments formarray
        this.updateDraftWorkout(); // trigger an initial draw of the chart
        this.subscribeToForm(); // detect form changes and update the chart
      },
      error => {
        // console.log(error);
      }
    );
  }

  // create blank workout object
  initNewWorkout() {
    this.workout = {
      "segments": [],
      "notes": "No description has been added for this Workout yet.",
      "hidden": false,
      "timeTotal": 0,
      "workoutType": "ftp",
      "title": "Draft Workout " + this.apiService.Parse.User.current().displayName,
      "category": {
        "__type": "Pointer",
        "className": "Category",
        "objectId": "c-my-workouts"
      },
      "startType": "flying",
      "createdAt": "2017-01-12T12:12:49.545Z",
      "updatedAt": "2017-06-13T13:56:49.332Z",
      "compatibleWith": 40000000,
      "type": "segments",
      "contentBundle":["default"],
      "ACL": {
        "role:Admin": {
          "read": true,
          "write": true
        },
        "role:Staff": {
          "read": true,
          "write": true
        },
        [this.apiService.Parse.User.current().id]: {
          "read": true,
          "write": true
        }
      }
    }
  }

  // init the form once we have data
  initForm() {
    this.form = new FormGroup({
      "title": new FormControl(this.workout['title'], Validators.required),
      "intro": new FormControl(this.workout['intro']),
      "hidden": new FormControl(this.workout['hidden']),
      "segments": this.formBuilder.array([]),
      "notes": new FormControl(this.workout['notes'])
    });
  }

  // validate data TODO: do full validation rather than set defaults
  validate(){
    // set some minimums
    let segments = this.form.controls.segments.value;
    segments.forEach(segment => {
      if (segment.start < 10){segment.start = 0;}
      if (segment.end < 10){segment.end = 0;}
      if (segment.cadence < 10){segment.cadence = 0;}
      if (segment.duration < 5){segment.duration = 5;}
      if (segment.hr < 10){segment.hr = 0;}
      if (segment.flashNote === ""){
        segment.flashNote = null;
        segment.flashNoteOffset = null;
      }
      if (segment.flashNote !== "" && (segment.flashNoteOffset === "" || segment.flashNoteOffset === null)){
        segment.flashNoteOffset = 0;
      }
      if (segment.flashNoteOffset === ""){segment.flashNoteOffset = null;}
      if (!segment.blockType){segment.blockType = "building";}
      if (!segment.blockId){segment.blockId = "fc38ce73-ba21-4b42-ac6f-ad982c80a630";}
      if (!segment.type){segment.type = "effort";}
      if (!segment.manuallyEdited){segment.manuallyEdited = true;}
    });
  }

  // populate the formArray with segments
  populateSegments(segments): void {
    let segmentsControl = this.form.controls.segments as FormArray;
    segments.forEach(segment => {

      // rebuild the segment array
      segmentsControl.push(this.formBuilder.group(segment))
    })
  }

  // create a blank workout segment
  createSegment(): FormGroup {
    return this.formBuilder.group({
      "duration": 300,
      "start": 100,
      "end": 100,
      "hr": 50,
      "cadence": 90,
      "lap": true,
      "flashNote": null,
      "flashNoteOffset": null,
      "manuallyEdited": true,
      "type": "effort",
      "blockType": "building",
      "blockId": "fc38ce73-ba21-4b42-ac6f-ad982c80a630"
    });
  }

  // update the draft workout we will utimately save
  updateDraftWorkout() {
    this.validate();
    this.sumTime();
    this.workout['timeTotal'] = this.timeTotal;
    this.workout['title'] = this.form.controls.title.value;
    this.workout['intro'] = this.form.controls.intro.value;
    this.workout['segments'] = this.form.controls.segments.value;
    this.workout['hidden'] = this.form.controls.hidden.value;
    this.workout['notes'] = this.form.controls.notes.value;
    this.buildProfile();
  }

  // subscribe to any form changes so the chart automatically updates
  subscribeToForm() {
    if (this.formWatcher) { this.unsubscribeToForm(); }
    this.formWatcher = this.form.valueChanges.subscribe(data => {
      this.validate();
      this.updateDraftWorkout();
    });
  }

  // unsubscribe from changes to stop tracking changes
  unsubscribeToForm() {
    this.formWatcher.unsubscribe();
  }

  // calculate total time, TODO: there are better ways to do this
  sumTime() {
    this.timeTotal = 0;
    let segments = this.form.controls.segments.value;
    segments.forEach(segment => {
      this.timeTotal += segment.duration;
    })
  }

  // reorder the segment array
  upSegment(index) {

    if (index == this.form.controls.segments.value.length - 1) { return; } // dont let the user push an element off the array

    let segments = this.form.controls.segments as FormArray;
    segments.controls = []; // clear the control values but don't disconnect parent

    let tempSegments = [];
    for (var i = 0; i < segments.value.length; i++) {
      if (i !== index) {
        tempSegments.push(segments.value[i]);
      }
      if (i == index + 1) {
        tempSegments.push(segments.value[index]);
      }
    }
    // this.truncateSegments(); // clear the form array
    this.populateSegments(tempSegments); // re-populate with the reordered array
    this.validate();
    this.activeSegmentIndex++;
    this.updateDraftWorkout() // update the chart
  }

  // reorder the segment array
  downSegment(index) {

    if (index == 0) { return; } // dont let the user push an element off the array

    let segments = this.form.controls.segments as FormArray;
    segments.controls = []; // clear the control values but don't disconnect parent
    let tempSegments = [];
    for (var i = 0; i < segments.value.length; i++) {
      if (i == index - 1) {
        tempSegments.push(segments.value[index]);
      }
      if (i !== index) {
        tempSegments.push(segments.value[i]);
      }
    }
    // this.truncateSegments(); // clear the form array
    this.populateSegments(tempSegments); // re-populate with the reordered array
    this.validate();
    this.activeSegmentIndex--;
    this.updateDraftWorkout() // update the chart
  }

  // reorder the segment array
  duplicateSegment(index) {

    let segments = this.form.controls.segments as FormArray;
    segments.controls = []; // clear the control values but don't disconnect parent
    let tempSegments = [];
    for (var i = 0; i < segments.value.length; i++) {

      // continue adding the existing segments
      tempSegments.push(segments.value[i]);

      // if we are at the insert point add the additional copy of the selected segment
      if (i == index) {
        tempSegments.push(segments.value[index]);
      }

    }
    // this.truncateSegments(); // clear the form array
    this.populateSegments(tempSegments); // re-populate with the reordered array
    this.validate();
    this.activeSegmentIndex++;
    this.updateDraftWorkout() // update the chart
  }

  // remove a segment
  removeSegment(index) {
    let segments = this.form.controls.segments as FormArray;
    segments.removeAt(index);
    this.updateDraftWorkout(); // update the chart
  }

  /**
  * Build the profile config object for highcharts including the series data arrays
  * @param {Object} workout - the workout object retuned from the API
  */
  buildProfile() {

    // MMP Zones
    // 0 : Recovery : < 35% --> #99cdff
    // 1 : Zone 1 Basic : 36% - 45% --> #aedc92
    // 2 : Zone 2 Basic : 46% - 55% --> #cefece
    // 3 : Zone 3 Intensive : 56% - 65% --> #feff99
    // 4 : Zone 4 Intensive : 66% - 75% --> #ffcc00
    // 5 : Zone 5 Maximal : 76% - 85% --> #ff9801
    // 6 : Zone 6 Maximal : 86% - 100% --> #ff6600
    // 7 : Supra-maximal : > 100% --> #ed1c24
    
    // FTP Zones
    // 1 : Active Recovery : < 55% --> #99cdff
    // 2 : Endurance : 56% - 75% --> #cefece
    // 3 : Tempo : 76% - 90% --> #feff99
    // 4 : Lactate Threshold : 91% - 105% --> #ffcc00
    // 5 : VO2max : 106% - 120% --> #ff9801
    // 6 : Anaerobic Capacity : 121% - 150% --> #ff6600
    // 7 : Supra-maximal : > 150% --> #ed1c24

    const mmpColours = {
      0: '#99cdff',
      1: '#aedc92',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    const ftpColours = {
      0: '#99cdff',
      1: '#99cdff',
      2: '#cefece',
      3: '#feff99',
      4: '#ffcc00',
      5: '#ff9801',
      6: '#ff6600',
      7: '#ed1c24'
    };

    var workoutProfileObject = {};
    var workoutType = 'ftp';
    var zonePowerTimes = [];
    if (workoutType == 'mmp') {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0, 0, 0];
    } else {
      workoutProfileObject = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [] }; // TODO: why did I use an object?
      zonePowerTimes = [0, 0, 0, 0, 0, 0];
    }
    var runningDuration = 0;
    var plotLinesLaps = [];

    let newHighchartsSeriesArray = [];

    // loop the segments and create the profile array data for highcharts
    for (var i = 0; i < this.form.controls.segments.value.length; i++) {

      // add to the laps array if needed
      if (this.form.controls.segments.value[i].lap === true) {
        plotLinesLaps.push({
          color: "rgba(0, 0, 0, .2)",
          dashStyle: "Dash",
          value: (runningDuration),
          width: "1",
          zIndex: 22,
          label: { enabled: false }
        });
      }

      // what zone is this segment
      let segmentZone = this.getMmpPowerZone(this.form.controls.segments.value[i].start, 'ftp');

      // build the highcarts series based on the segment, one series per segment
      let fillOpacity = 1;
      let lineWidth = 0;
      let zIndex = undefined;
      if (i == this.activeSegmentIndex) {
        fillOpacity = 0.5;
        lineWidth = 2;
        zIndex = 1;
      };
      newHighchartsSeriesArray.push({
        name: i,
        data: [
          // [0, 0],
          [runningDuration, 0],
          [runningDuration, this.form.controls.segments.value[i].start],
          [runningDuration + this.form.controls.segments.value[i].duration, this.form.controls.segments.value[i].start],
          [runningDuration + this.form.controls.segments.value[i].duration, 0]
        ],
        color: ftpColours[segmentZone],
        fillOpacity: fillOpacity,
        linecap: 'square',
        lineColor: '#555',
        lineWidth: lineWidth,
        zIndex: zIndex
      });

      runningDuration += this.form.controls.segments.value[i].duration;

    }

    // get the configs
    this.profileChartOptions = this.chartsService.workoutProfileChartNew(newHighchartsSeriesArray, workoutType, plotLinesLaps);

  }

  chartClickHandler(event: any) {
    if (event.point) {
      this.showSegment(event.point.series.index);
    }
  }

  showSegment(segment: number) {
    this.activeSegmentIndex = segment;
    this.updateDraftWorkout() // update the chart
  }

  getMmpPowerZone(percentMmpPower, workoutType) {

    const mmpPowerBands = [0, 35, 45, 55, 65, 75, 85, 100, 1000];
    const ftpPowerBands = [0, 55, 75, 90, 105, 120, 150, 1000];
    // const mmpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];
    // const ftpHrBands = [0, 60, 65, 75, 82, 89, 94, 100, 1000];

    if (workoutType == 'ftp') {
      if (percentMmpPower > ftpPowerBands[0] && percentMmpPower < ftpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= ftpPowerBands[1] && percentMmpPower <= ftpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= ftpPowerBands[2] && percentMmpPower <= ftpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= ftpPowerBands[3] && percentMmpPower <= ftpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= ftpPowerBands[4] && percentMmpPower <= ftpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= ftpPowerBands[5] && percentMmpPower <= ftpPowerBands[6]) { return 5; }
      else { return 0; }
    } else {
      if (percentMmpPower > mmpPowerBands[0] && percentMmpPower < mmpPowerBands[1]) { return 0; }
      else if (percentMmpPower >= mmpPowerBands[1] && percentMmpPower <= mmpPowerBands[2]) { return 1; }
      else if (percentMmpPower >= mmpPowerBands[2] && percentMmpPower <= mmpPowerBands[3]) { return 2; }
      else if (percentMmpPower >= mmpPowerBands[3] && percentMmpPower <= mmpPowerBands[4]) { return 3; }
      else if (percentMmpPower >= mmpPowerBands[4] && percentMmpPower <= mmpPowerBands[5]) { return 4; }
      else if (percentMmpPower >= mmpPowerBands[5] && percentMmpPower <= mmpPowerBands[6]) { return 5; }
      else if (percentMmpPower >= mmpPowerBands[6] && percentMmpPower <= mmpPowerBands[7]) { return 6; }
      else if (percentMmpPower >= mmpPowerBands[7] && percentMmpPower <= mmpPowerBands[8]) { return 7; }
      else { return 0; }
    }

  }

  import(event){

    const reader = new FileReader();
    const file: File = event.srcElement.files[0];
    const nameBits = event.srcElement.files[0]['name'].split('.');
    const extension: string = nameBits[nameBits.length -1];

    // accepted types
    if(extension != 'tcx' && extension != 'json'){return;}

    // read the content and process as needed
    reader.readAsText(event.srcElement.files[0]);
    let that = this;
    reader.onload = function () {
      if(extension == 'tcx'){
        that.importTcx(reader.result);
      }else{
        alertify.error("Only TCX files are currently supported");
      }
    }

  }

  // Import a tcx file
  importTcx(tcxString = null) {

    if(!tcxString){return false;}

    let tcxObject = this.filesService.tcxToObject(tcxString);
    const tcxLaps = tcxObject['TrainingCenterDatabase']['Activities'][0]['Activity'][0]['Lap'];
    let tempSegments = [];
    let maxSegments = 400; // tcx files can have tens of thousands of trackpoints, so limit to this
    let runningTime = new Date (tcxLaps[0]['Track'][0]['Trackpoint'][0]['Time']);

    // calculate step
    let totalTrackpoints = 0;
    for (let i = 0; i < tcxLaps.length; i++) {
      totalTrackpoints += tcxLaps[i]['Track'][0]['Trackpoint'].length;
    }
    let step = Math.round(totalTrackpoints / maxSegments);
    if (step < 1){step = 1;}
    // let step = 1;

    // loop the laps and trackpoints and build up a profile of the workout
    for (let i = 0; i < tcxLaps.length; i++) {
      let trackpoints = tcxLaps[i]['Track'][0]['Trackpoint'];

      for (let j = 0; j < trackpoints.length-step; j=j+step) {
        let watts = trackpoints[j]['Extensions'][0]['TPX'][0]['Watts'];
        let speed = trackpoints[j]['Extensions'][0]['TPX'][0]['Speed'];
        let cadence = trackpoints[j]['Cadence'];
        let distance = trackpoints[j]['DistanceMeters'];
        let hr = trackpoints[j]['HeartRateBpm'];
        let currentTime = new Date(trackpoints[j]['Time']).getTime();
        let nextTime = new Date(trackpoints[j+step]['Time']).getTime();
        let duration = Math.round((nextTime - currentTime)/1000);
        // if(duration < 0){console.log("Err: " + trackpoints[j+step]['Time'] + " " + trackpoints[j]['Time']);}

        // console.log("Watts: " + watts + " FTP: " + this.userPerformanceState['ftp']);

        tempSegments.push({
          "duration": duration,
          "start": Math.round((watts / this.userPerformanceState['ftp']) * 100),
          "end": Math.round((watts / this.userPerformanceState['ftp']) * 100),
          "hr": parseInt(hr),
          "cadence": parseInt(cadence),
          "lap": false,
          "flashNote": null,
          "flashNoteOffset": null
        });
      }

      // clear the segments array and replace with the import
      let segments = this.form.controls.segments as FormArray;
      segments.controls = []; // clear the control values but don't disconnect parent
      this.populateSegments(tempSegments); // re-populate with the reordered array
      this.validate();
      this.activeSegmentIndex = null;
      this.updateDraftWorkout() // update the chart

    }

  }

  // export - download a txt version of the workout object
  exportJson() {
    let workoutData = JSON.stringify(this.workout);
    let blob = new Blob([workoutData], { type: 'text/json' });
    let url = window.URL.createObjectURL(blob);
    var now = new Date();
    let dateString = now.toISOString().substring(0, 10);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, this.workout['title'] + ' - ' + dateString + '.json');
    } else {
      let a = document.createElement('a');
      a.href = url;
      a.download = this.workout['title'] + '-' + dateString + '.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }

  // insert a set of segments
  insert(set: string = 'newSegment', position: string = 'current') {

    // get the current segments state
    let segments = this.form.controls.segments.value;

    // clear the FormArray control values but don't disconnect parent
    let currentSegments = this.form.controls.segments as FormArray;
    currentSegments.controls = [];

    // add the new set of segments at the correct position
    if (this.insertSets[set].segments) {
      if (position == 'start') {
        segments = this.insertSets[set].segments.concat(segments);
      } else if (position == 'current' && this.activeSegmentIndex != null) {
        let tempSegments = [];
        for (let i = 0; i < segments.length; i++) {
          // add the existing segment to the temp array
          tempSegments.push(segments[i]);
          // loop through the insert set and add the segments
          if(i == this.activeSegmentIndex){
            for (let j = 0; j < this.insertSets[set].segments.length; j++) {
              tempSegments.push(this.insertSets[set].segments[j]);
            }
          }
        }
        segments = tempSegments;
      } else {
        segments = segments.concat(this.insertSets[set].segments);
      }
    }

    // repopulate the form segments and update the chart
    this.populateSegments(segments); // re-populate with the reordered array
    this.updateDraftWorkout() // update the chart

  }

  // format the form data and post to Hub API service
  submitForm() {
    this.updateDraftWorkout();
    this.workout['segments'][0].lap = false; // segment 1 should never have a lap

    console.log(JSON.stringify(this.workout));

    if (!this.workout['objectId']) {
      // POST the new workout
      this.hubService.postResource('classes/Workout', this.workout)
        .subscribe(
        workout => {
          // console.log(workout);
          alertify.success("Workout created");
          this.router.navigateByUrl('/workouts/edit/'+workout.objectId); // navigate to edit this workout once saved
        },
        error => {
          console.log(JSON.stringify(error));
          alertify.error(error);
        }
        );
    } else {
      // PUT an update
      // - only update what we need to
      let saveWorkout = {
        timeTotal: this.workout['timeTotal'],
        title: this.workout['title'],
        intro: this.workout['intro'],
        segments: this.workout['segments'],
        notes: this.workout['notes'],
      }

      this.hubService.putResource('Workout', this.workout['objectId'], saveWorkout)
        .subscribe(
        workout => {
          // console.log(workout);
          alertify.success("Workout updated");
        },
        error => {
          console.log(error);
          // console.log(JSON.stringify(this.workout));
          alertify.error(error);
        }
        );
    }

  }

  toggleNotesAccordion() {
    if (this.notesVisible == true) {
      this.notesVisible = false;
    } else {
      this.notesVisible = true;
    }
  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/workout-editor/workout-editor.component.ts